module.exports={
  "id": "abundant-buffet",
  "name": "Abundant buffet",
  "subtext": "Satisfy a crowd with a diverse array of dishes that cater to every appetite and any preference. Chafer stands and heat are included.",
  "coverImage": "https://img.peerspace.com/image/upload/v1725383524/wtm0tnw3sri9s7gqdpfi.jpg",
  "price": {
    "value": 49.0,
    "per_person": true
  },
  "menu": {
    "menu_sections": [
      {
        "id": "starters-selections",
        "title": "Salads and starters (select 1)",
        "min_selections": 1,
        "max_selections": 1,
        "items": [
          {
            "name": "Greek salad with tomatoes, cucumbers, kalamata olives, feta cheese",
            "price": {
              "value": 0.0
            }
          },
          {
            "name": "Southwest salad with black beans, roasted corn, cojita cheese, cilantro",
            "price": {
              "value": 0.0
            }
          },
          {
            "name": "Caesar salad with croutons and parmesan cheese",
            "price": {
              "value": 0.0
            }
          },
          {
            "name": "Asian style vegetable dumplings with soy dipping sauce",
            "price": {
              "value": 0.0
            }
          },
          {
            "name": "Hummus or spinach dip with baguette",
            "price": {
              "value": 0.0
            }
          }
        ]
      },
      {
        "id": "mains-selections",
        "title": "Mains (select 2)",
        "min_selections": 2,
        "max_selections": 2,
        "items": [
          {
            "name": "Beef tips with mushroom sauce and mashed potatoes",
            "price": { "value": 0.0 }
          },
          {
            "name": "Seared salmon with chef’s choice of sauce and quinoa",
            "price": { "value": 0.0 }
          },
          {
            "name": "Shrimp pad thai with eggs, peanuts, vegetables",
            "price": { "value": 0.0 }
          },
          {
            "name": "Penne all'arrabbiata with grilled chicken",
            "price": { "value": 0.0 }
          },
          {
            "name": "Pulled pork with barbecue sauce, pickled onion, and grilled corn",
            "price": { "value": 0.0 }
          },
          {
            "name": "Cobb salad with egg, bleu cheese, bacon, chicken",
            "price": { "value": 0.0 }
          }
        ]
      },
      {
        "id": "sweets-selections",
        "title": "Sweets (select 1)",
        "min_selections": 1,
        "max_selections": 1,
        "items": [
          {
            "name": "Flourless chocolate cake",
            "price": { "value": 0.0 }
          },
          {
            "name": "Apple crisp with vanilla sauce",
            "price": { "value": 0.0 }
          },
          {
            "name": "NY style cheesecake with seasonal fruit",
            "price": { "value": 0.0 }
          }
        ]
      }
    ]
  },
  "description": "Lots of options including: salads, dumplings, beef tips, penne all'arrabbiata, seared salmon, shrimp pad thai, apple crisp, and NY style cheesecake."
}
